import { BUSINESS_BOOKING_API_URL } from '../library/globals';
import { GET } from './api-hander.service';
import { FETCH_PRINT_HISTORY } from './api.constants';

export const getPrintHistory = async (body = {}) => {
    return GET(`${BUSINESS_BOOKING_API_URL}${FETCH_PRINT_HISTORY}`, { ...body });
};
